var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"circle-ul"},_vm._l((_vm.imageList),function(item,index){return _c('li',{key:item.id,staticClass:"circle-li"},[_c('div',{staticClass:"imagContainer",on:{"click":function($event){return _vm.changeList(index)}}},[_c('img',{class:_vm.SelectClass(index),attrs:{"src":item,"alt":""}})])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06855d09","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/FriendGroup_ChoisePhoto.vue
// module id = null
// module chunks = 